import React from 'react';
import { socialLinks } from '../../data/mock';
import { Instagram, Facebook, Heart } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const handleScroll = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-charcoal py-12">
      <div className="container mx-auto px-6">
        <div className="flex flex-col items-center">
          {/* Logo */}
          <a
            href="#"
            onClick={(e) => handleScroll(e, '#')}
            className="font-playfair text-2xl text-white mb-6 hover:text-warm-sage transition-colors"
          >
            NekedSzedtem
          </a>

          {/* Social Links */}
          <div className="flex items-center gap-6 mb-8">
            <a
              href={socialLinks.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-warm-sage transition-colors group"
              aria-label="Instagram"
            >
              <Instagram className="w-5 h-5 text-white" />
            </a>
            <a
              href={socialLinks.facebook}
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-warm-sage transition-colors group"
              aria-label="Facebook"
            >
              <Facebook className="w-5 h-5 text-white" />
            </a>
          </div>

          {/* Divider */}
          <div className="w-24 h-px bg-white/20 mb-8" />

          {/* Copyright */}
          <div className="text-center">
            <p className="font-montserrat text-sm text-white/60 mb-2">
              © {currentYear} NekedSzedtem – Minden jog fenntartva.
            </p>
            <p className="font-montserrat text-xs text-white/40 flex items-center justify-center gap-1">
              Készítve <Heart className="w-3 h-3 text-warm-sage" /> szeretettel
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
